import { ErrorStore } from "./errorTypes";

export function selectCurrentError({ errors }: ErrorStore) {
    return errors.currentError
}

export function selectErrors({ errors }: ErrorStore) {
    return errors.errors
}
